import PrivacyPolicy from "./PrivacyPolicy";

export const routes = [
    {
        path: "/privacy-policy",
        component: PrivacyPolicy,
        exact: true,
        showNav: true
    }
]